import { Mention, MentionsInput } from "react-mentions";

interface Props {
  readOnly?: boolean;
  size?: string;
  value: string;
  handleInputChange: (e: any, newVal: string) => void;
  options: { id: string; display: string }[];
  placeholder?: string;
}

export default function AppMentionsInput({
  readOnly = false,
  size = "sm",
  value,
  handleInputChange,
  options,
  placeholder,
}: Props) {
  return (
    <MentionsInput
      readOnly={readOnly}
      disabled={readOnly}
      style={{
        whiteSpace: "pre-wrap",
        "&singleLine": {
          display: "block",
          width: "100%",
          height:
            size === "sm"
              ? "calc( 0.45em + 1.25rem + 5px)"
              : "calc( 1.5em + 1.25rem + 5px)",
          transition: "all 0.15s ease-in-out",
          fontWeight: "400",
          lineHeight: 1.5,
          color: "var(--dark)",
          boxShadow: "0 3px 2px rgb(198 202 199 / 5%)",
          backgroundClip: "padding-box",
          fontSize: "0.875rem",
          highlighter: {
            padding: size === "sm" ? "0.25rem 0.5rem" : "0.75rem 0.75rem",
          },
          input: {
            transition: "all 0.15s ease-in-out",
            fontWeight: "400",
            lineHeight: 1.5,
            color: "var(--dark)",
            borderRadius: "0.25rem",
            boxShadow: "0 3px 2px rgb(198 202 199 / 5%)",
            border: "1px solid #b0b4b1",
            backgroundClip: "padding-box",
            height:
              size === "sm"
                ? "calc( 0.45em + 1.25rem + 5px)"
                : "calc( 1.5em + 1.25rem + 5px)",
            padding: size === "sm" ? "0.25rem 0.5rem" : "0.625rem 0.75rem",
            fontSize: "0.875rem",
          },
        },
        control: {
          backgroundColor: readOnly ? "#ededed" : "#fff",
          fontSize: 14,
          fontWeight: "normal",
        },
        suggestions: {
          list: {
            backgroundColor: "white",
            border: "1px solid rgba(0,0,0,0.15)",
            fontSize: "14px",
            borderRadius: "6px",
            boxShadow: "0 0 2rem 0 rgb(110 112 111 / 15%) !important",
            maxHeight: "200px",
            overflowY: "scroll",
          },
          item: {
            padding: "5px 15px",
            borderBottom: "1px solid rgba(0,0,0,0.15)",
            "&focused": {
              backgroundColor: "var(--primary)",
              color: "var(--white)",
            },
          },
        },
      }}
      value={value}
      onChange={handleInputChange}
      singleLine={true}
      placeholder={options?.length ? "Insert Fields Using '{'" : placeholder}
      a11ySuggestionsListLabel={"Suggested Fields"}
      //   allowSpaceInQuery={true}
    >
      <Mention
        trigger="{"
        data={options}
        markup="{{__id__}}"
        style={{
          backgroundColor: "var(--superlight)",
          color: "var(--dark)",
          zIndex: 99999,
          borderRadius: 4,
        }}
      ></Mention>
    </MentionsInput>
  );
}
